// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vdc-conversations-history {
  /* flex: 1; */
  overflow-y: scroll;
  padding: 16px;
  height: 560px;
  border-radius: 10px;
  border-right: 2px solid darkslategray;
  position: fixed;
}

.Member-Chat-Click-container {
  padding: "8px 12px";
  border-radius: 10px;
  background-color: none;
  color: white;
  border: none;
  width: 100px;
  height: 40px;
  font-size: 25px;
  position: fixed;
  align-self: flex-end;
  margin-left: 50px;
}

.uac-search-input-container {
  flex: 1 1;
  border-radius: 10px;
  border: "1px solid #ccc";
  width: 60%;
  height: 100%;
  margin-left: 20px;
}

.vdc-message-display {
  width: 100%;
  height: 450px;
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/common/VideoCall/Styles/VDCGridLeftLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".vdc-conversations-history {\n  /* flex: 1; */\n  overflow-y: scroll;\n  padding: 16px;\n  height: 560px;\n  border-radius: 10px;\n  border-right: 2px solid darkslategray;\n  position: fixed;\n}\n\n.Member-Chat-Click-container {\n  padding: \"8px 12px\";\n  border-radius: 10px;\n  background-color: none;\n  color: white;\n  border: none;\n  width: 100px;\n  height: 40px;\n  font-size: 25px;\n  position: fixed;\n  align-self: flex-end;\n  margin-left: 50px;\n}\n\n.uac-search-input-container {\n  flex: 1;\n  border-radius: 10px;\n  border: \"1px solid #ccc\";\n  width: 60%;\n  height: 100%;\n  margin-left: 20px;\n}\n\n.vdc-message-display {\n  width: 100%;\n  height: 450px;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
